import { createContext } from 'preact';

export const ThreadCountContext = createContext(0);
